<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>小微子商户报件</h1>
        <p>该接口报件完成后，调用图片上传接口上传图片资料</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0201</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（15）</td><td>是</td><td>邮件给的orgCd,合作方唯一</td></tr>
          <tr><td>商户全称</td><td>mchtName</td><td>String（150）</td><td>是</td><td>身份证名字</td></tr>
          <tr><td>角色</td><td>mchtRole</td><td>String（3）</td><td>是</td><td>固定600:商户</td></tr>
          <tr><td>商户简称</td><td>mchtCnAbbr</td><td>String（60）</td><td>是</td><td>身份证名字</td></tr>
          <tr><td>联系人姓名</td><td>contact</td><td>String（30）</td><td>是</td><td>身份证名字</td></tr>
          <tr><td>联系人类型</td><td>contactClass</td><td>String（30）</td><td>是</td><td>法人：LEGAL_PERSON</td></tr>
          <tr><td>联系人客户电话</td><td>commMobil</td><td>String（20）</td><td>是</td><td>商户自己手机号码</td></tr>
          <tr><td>联系人电话</td><td>commTel</td><td>String（20）</td><td>是</td><td>商户自己手机号码</td></tr>
          <tr><td>法人姓名</td><td>manager</td><td>String（50）</td><td>是</td><td>身份证名字</td></tr>
          <tr><td>法人证件类型</td><td>artifCertifTp</td><td>String（2）</td><td>是</td><td>身份证：00</td></tr>
          <tr><td>法人证件号码</td><td>identityNo</td><td>String（20）</td><td>是</td><td>身份证号码</td></tr>
          <tr><td>法人联系电话</td><td>managerTel</td><td>String（12）</td><td>是</td><td>商户自己手机号码</td></tr>
          <tr><td>证件类型</td><td>licenseType</td><td>String（32）</td><td>是</td><td>身份证：NATIONAL_IDENTITY</td></tr>
          <tr><td>商户证件编号号码</td><td>licenceNo</td><td>String（20）</td><td>是</td><td>身份证号码</td></tr>
          <tr><td>商户证件有效期</td><td>licenceEndDate</td><td>String（8）</td><td>是</td><td>身份证有效期</td></tr>
          <tr><td>省代码</td><td>provinceCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>市代码</td><td>cityCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>区代码</td><td>districtCode</td><td>String（10）</td><td>是</td><td></td></tr>
          <tr><td>注册地址</td><td>regAddr</td><td>String（60）</td><td>是</td><td>个人填住址</td></tr>
          <tr><td>营业性质</td><td>busType</td><td>String（60）</td><td>是</td><td>3：自然人</td></tr>
          <tr><td>外部商户号</td><td>outMchtCd</td><td>String（15）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户开户总行</td><td>settleHeadBankNo</td><td>String（40）</td><td>是</td><td></td></tr>
          <tr><td>商户结算帐户开户行</td><td>settleBankNo</td><td>String（40）</td><td>是</td><td>开户支行号</td></tr>
          <tr><td>商户结算帐户开户行名称</td><td>settleBankNm</td><td>String（256）</td><td>是</td><td>开户支行名称</td></tr>
          <tr><td>商户结算帐户号</td><td>settleAcct</td><td>String（40）</td><td>是</td><td>银行卡号</td></tr>
          <tr><td>商户结算帐户户名</td><td>settleAcctNm</td><td>String（256）</td><td>是</td><td>身份证名字</td></tr>
          <tr><td>账户类型</td><td>acctType</td><td>String（1）</td><td>是</td><td>1 ：对私</td></tr>
          <tr><td>开户地址</td><td>openAcctAddr</td><td>String（512）</td><td>是</td><td>开户的省市，如：广东广州</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String（15）</td><td>是</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Zshbj',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/xwzshbj.vue